import React from 'react'
import {AppBar, Grid, Typography} from '@material-ui/core';
import Tr from 'translations/Translations';
import {makeStyles} from "@material-ui/styles";
import PropTypes from "prop-types";
import {getUserFullNameWithDeputy} from "libs/userNameGetter";

const useStyle = makeStyles(theme => ({
    root: {
        borderBottom: `solid 1px ${theme.palette.primary.main}`,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.greyBackground,
    }
}))

function PurchaserGroupInfoBar(
    {
        purchaserGroupHeader
    }) {
    const classes = useStyle();

    return (
        <>
            <AppBar
                id='appBar'
                className={classes.root}
                component='div'
                elevation={0}
                position='relative'
            >
                <Grid
                    container
                    direction='column'
                >
                    <Typography>
                        <b>{Tr('name')}:{' '}</b>{purchaserGroupHeader.name}
                    </Typography>
                    <Typography>
                        <b>{Tr('demand_number')}:{' '}</b>{purchaserGroupHeader.number}
                    </Typography>
                    <Typography>
                        <b>{Tr('purchasing_group_author')}:{' '}</b>{getUserFullNameWithDeputy(purchaserGroupHeader.author)}
                    </Typography>
                </Grid>
            </AppBar>
        </>
    )
}

PurchaserGroupInfoBar.propTypes = {
    purchaserGroupHeader: PropTypes.object.isRequired
}


export default PurchaserGroupInfoBar;
